import '@/plugins/logger'

import webfontloader from '@/plugins/webfontloader'
import 'lazysizes'
import { snif } from '@/plugins/snif'

if (module.hot) {
	module.hot.accept()
}

webfontloader()
if ('touchAction' in document.body.style) {
	document.body.style.touchAction = 'manipulation'
}

if (snif.isIE) {
	document.body.classList.add('is-ie')
}

async function init() {
	const [App, routes] = await Promise.all([
		import(/* webpackChunkName: "chunk-app" */ '@/core/App'),
		import(/* webpackChunkName: "chunk-views" */ '@/views')
	])

	document.body.setAttribute('data-transition-state', 'on-load')
	/* eslint-disable-next-line */
	new App.default({
		// @property {Array} routes - routes object
		// @property {HTMLElement} rootNode - the root html node
		// @property {Array} navLinks - an array of links that should update on navigation
		// @property {Object} classes - clases applied to active links
		// @property {Function} onExit - called before the dom is updated
		// @property {Function} function - called after the dom is updated
		router: {
			routes: routes.default,
			rootNode: document.getElementById('page-wrapper'),
			navLinks: [
				...document.querySelectorAll('header a'),
				...document.querySelectorAll('footer a')
			],
			classes: {
				match: 'is-current',
				root: 'is-current-root',
				parent: 'is-current-parent'
			},
			prefetchTargets: null,
			onExit() { },
			onEnter() { }
		},

		// @property {Function} routes - dynamic import of modules - function used by the loader
		chunks: behaviour =>
			import(/* webpackChunkName: "behaviour-[request]" */ `@/behaviours/${behaviour}`)
	}).mount()
}

init()


// Handle tabs gracefully as per https://hackernoon.com/removing-that-ugly-focus-ring-and-keeping-it-too-6c8727fefcd2
const handleFirstTab = (e) => {
	if (e.keyCode === 9) {
		document.documentElement.classList.add('-is-tabbing')

		window.removeEventListener('keydown', handleFirstTab)
		window.addEventListener('mousedown', handleMouseDownOnce) // eslint-disable-line
	}
}

const handleMouseDownOnce = () => {
	document.documentElement.classList.remove('-is-tabbing')

	window.removeEventListener('mousedown', handleMouseDownOnce)
	window.addEventListener('keydown', handleFirstTab)
}

window.addEventListener('keydown', handleFirstTab)
